<template>
  <section v-if="!(item.meta && item.meta.hidden)">
    <app-link
      v-if="hasOneShowingChild(item.children, item)
        && !onlyOneChild.children
        && !item.meta?.visible
        && onlyOneChild.meta"
      :to="resolvePath(onlyOneChild.path)"
      :is-blank="onlyOneChild.meta && onlyOneChild.meta.isBlank"
    >
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{'is-collapse-item-sid':isCollapse, 'no-drop': !isNest, 'is-active': activeMenu?.indexOf(onlyOneChild.meta?.childrenPath) > -1}"
      >
        <!-- 菜单icon尽量让设计师设计 -->
        <!-- 当前选中的icon -->
        <template v-if="activeMenu === onlyOneChild.path || activeMenu?.indexOf(onlyOneChild.meta?.childrenPath) > -1">
          <svg-icon
              style="color:#fff;"
              v-if="onlyOneChild.meta.icon || (item.meta && item.meta.iconActive)"
              :icon-class="item.meta && item.meta.iconActive"
              :class-name="isCollapse ? 'menu-icon' : 'menu-icon mr-6'"
          />
        </template>
        <template v-else>
          <svg-icon
              style="font-size: 18px"
              v-if="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
              :icon-class="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
              :class-name="isCollapse ? 'menu-icon' : 'menu-icon mr-6'"
          />
        </template>
        <div v-if="isCollapse" class="is-collapse-item-sid-label">
          {{ onlyOneChild.meta.title  || item.meta.title}}
        </div>
        <template #title>
         {{ onlyOneChild.meta.title  || item.meta.title}}
        </template>
      </el-menu-item>
    </app-link>

    <el-sub-menu
      v-else
      :index="resolvePath(item.path)"
    >
      <template
        v-if="item.meta"
        #title
      >
        {{activeMenu}}
        <svg-icon
          v-if="item.meta.icon"
          :icon-class="item.meta.icon"
          :class-name="isCollapse ? 'menu-icon' : 'menu-icon mr-6'"
        />
        <span>{{ item.meta.title || '' }}</span>
      </template>

      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :is-nest="true"
        :base-path="resolvePath(child.path)"
        :is-collapse="isCollapse"
        class="nest-menu"
      />
    </el-sub-menu>
  </section>
</template>
<script lang="ts">
import {defineComponent, reactive,ref, toRefs, watch} from 'vue';
  import path from 'path-browserify';
  import { isExternal } from '@/utils/validate';
  import AppLink from './Link.vue';
import {useRoute} from "vue-router";

  interface InterfaceState {
    onlyOneChild: TypeObject,
    basePath: string
  }

  export default defineComponent({
    name: 'sidebar-item',
    components: { AppLink },
    props: {
      item: {
        type: Object,
        required: true,
      },
      isNest: {
        type: Boolean,
        default: false,
      },
      basePath: {
        type: String,
        default: '',
      },
      isCollapse: {
        type: Boolean,
        default: false,
      },
    },
    setup(props) {
      const state: InterfaceState = reactive({
        onlyOneChild: {},
        basePath: '',
      });
      const route = useRoute();
      let activeMenu:any = ref('')
      watch(route, (val) => {
        activeMenu.value = val?.meta?.activeMenu || val.path;
      }, {
        immediate: true,
      });
      return {
        activeMenu,
        ...toRefs(state),
        hasOneShowingChild: (children: any, parent: any): boolean => {
          children = children || [];
          const showingChildren = children.filter((item: any) => {
            if (item.hidden) {
              return false;
            }
            state.onlyOneChild = item;
            return !(item.meta && item.meta.hidden);
          });
          if (showingChildren.length === 1) {
            // When there is only one child router, the child router is displayed by default
            state.onlyOneChild = children[0];
            return true;
          }
          if (showingChildren.length === 0) {
            // Show parent if there are no child router to display
            state.onlyOneChild = { path: '', ...parent };
            return true;
          }
          return false;
        },
        resolvePath: (routePath: any): string => {
          if (isExternal(routePath)) {
            return routePath;
          }
          if (isExternal(props.basePath)) {
            return props.basePath;
          }
          return path.resolve(props.basePath, routePath);
        },
      };
    },
  });
</script>
<style lang="scss" scoped>
  .menu-icon {
    font-size: 20px;

    &.mr-6 {
      margin-right: 6px;
    }
  }

  :deep(.el-menu-item) {
    // 解决折叠时 菜单icon 抖动问题
    div {
      display: flex !important;
      align-items: center !important;
    }
  }
</style>
<style lang="scss">
.el-menu.el-menu--vertical,.el-menu.el-menu--vertical .el-sub-menu {
  //.is-active {
  //  color: #409eff;
  //  background: linear-gradient(90deg, #E6EFFF 0%, #EDF3FF 9.64%, #F2F7FF 83.33%);
  //  // .el-sub-menu__title{
  //  // color: #007AF5;
  //  // font-weight: 600;
  //  // }
  //}
  .is-collapse-item-sid{
    height: 52px !important;
    .el-menu-tooltip__trigger{
      padding: 0 !important;
      justify-content: center;
      flex-wrap: wrap;
      align-content: center;
    }
    .is-collapse-item-sid-label{
      font-size: 10px;
      display: block;
      height: 20px;
      text-align: center;
      animation-duration: 300ms;
    }
  }
}
</style>
